import React from "react";
import { Page } from "@vitalsource/vstui-icons";
import ButtonStrip from "../../../common/ButtonStrip";
import { useIntl } from "react-intl";

interface DPSpageView {
  dpsOn: () => void;
  dpsOff: () => void;
  twoPageSpread: boolean;
}

const TwoPage = () => {
  return (
    <>
      <Page style={{ marginRight: "3px", transform: "scale(-1, 1)" }} />
      <Page />
    </>
  );
};

const PageView = (props: DPSpageView) => {
  const intl = useIntl();
  return (
    <ButtonStrip
      selectedButton={props.twoPageSpread ? 1 : 0}
      buttons={[
        {
          icon: Page,
          label: intl.formatMessage({ id: "format.onePage" }),
          onClick: props.dpsOff,
        },
        {
          icon: TwoPage,
          label: intl.formatMessage({ id: "format.twoPage" }),
          onClick: props.dpsOn,
        },
      ]}
    />
  );
};

export default PageView;
